// "New"-communicatie rond de vernieuwde Sort mode (gelanceerd juli 2026).
// Eén gedeelde vervaldatum: na deze datum verdwijnen de New-badges en de
// eenmalige intro-kaart vanzelf - eeuwige "New"-badges devalueren.
export const SORT_MODE_NEW_UNTIL = '2026-08-14';

export function isSortModeNew() {
  return new Date() < new Date(SORT_MODE_NEW_UNTIL);
}
